jQuery(document)
		.ready(
				function() {

					$('input[name="date"]').mask('00/00/0000');
					$('input[name="cpf"]').mask('000.000.000-00');
					$('input[name="phone"]').mask('(00) 0000-0000');
					$('input[name="cellphone"]').mask('(00) 00000-0000');
					$('input[name="cep"]').mask('00000-000');
					$('input[name="money"]').mask('0.000.000,00', {
						reverse : true
					});

					// Truncate Blog text
					// ==========================================================================
					(function() {
						$('.post .article-body p:not(:first-child)').remove();
						$('.post .article-body p').each(function() {
							truncate(this, 100, '...');
						});
					}());

					// Main Layout Animating Js
					var animating = false;
					var mainContent = document
							.querySelector('.angles-container .angles-content')
					mainContent.addEventListener('scroll', function(e) {
						var scroll = mainContent.scrollTop;

						if (scroll > 128) {
							$('.angles-wrapper').addClass('is-sticky');
							// $('footer').fadeOut('8000');
						} else {
							$('.angles-wrapper').removeClass('is-sticky');
							// $('footer').fadeIn('8000');
						}
					});

					function noScroll() {
						$('.angles-wrapper').removeClass('is-sticky');
					}

					function isScroll() {
						var height = $('.angles-page-content .angles-content')
								.height()
								- $('.angles-wrapper_page.active').find(
										'.content-bottom').height();
						return height < 2 ? true : false;
					}

					function menuToggle() {
						$(
								".angles-wrapper_page, .main-content, .angles-wrapper_menu")
								.toggleClass("menu-active");
						$(".js-menuBtn").toggleClass("m--btn");
						$(document).off("click", ".angles-wrapper_content",
								closeNotFocusedMenu);
					}

					function closeNotFocusedMenu(e) {
						if (!$(e.target).closest(".angles-wrapper_menu").length) {
							menuToggle();
						}
					}

					$(document).on(
							"click",
							".js-menuBtn",
							function() {
								if (animating)
									return;
								menuToggle();
								$(document).on("click",
										".angles-wrapper_content",
										closeNotFocusedMenu);
							});

					$(document)
							.on(
									"click",
									".angles-menu-item:not(.js-menuBtn)",
									function() {
										animating = true;
										var $this = $(this);
										var page = +$this.data("page");
										$(".js-menuBtn").removeClass(
												"js-menuBtn");
										$(".angles-wrapper_page.active")
												.removeClass("active");
										$this.addClass("js-menuBtn m--btn");
										$(".angles-wrapper_page-" + page)
												.addClass("active");
										$(
												".angles-wrapper_page, .main-content, .angles-wrapper_menu")
												.removeClass("menu-active");
										$(document).off("click",
												".angles-wrapper_content",
												closeNotFocusedMenu);
										setTimeout(
												function() {
													$(".angles-wrapper_menu")[0].className = $(".angles-wrapper_menu")[0].className
															.replace(
																	/\bpage-active-.*\b/gi,
																	"");
													$(".angles-wrapper_menu")
															.addClass(
																	"page-active-"
																			+ page);
													animating = false;

													if (isScroll()) {
														actionOnScroll();
													} else {
														noScroll();
													}

												}, 1000);
									});

					$('[data-toggle="tooltip"]').tooltip();

					jQuery(window).load(function() {
						// will first fade out the loading animation
						jQuery(".status").fadeOut();
						// will fade out the whole DIV that covers the website.
						jQuery(".preloader").delay(1000).fadeOut("slow");
					});

					// Animsition
					$(".animsition")
							.animsition(
									{
										inClass : 'fade-in',
										outClass : 'fade-out',
										inDuration : 800,
										outDuration : 800,
										linkElement : '.animsition-link',

										loading : true,
										loadingParentElement : 'body', // animsition
										// wrapper
										// element
										loadingClass : 'animsition-loading',
										loadingInner : '<img src="images/pre-loader.gif" />', // e.g
										// '<img
										// src="loading.svg"
										// />'
										unSupportCss : [ 'animation-duration',
												'-webkit-animation-duration',
												'-o-animation-duration' ],
										overlay : false,
										overlayClass : 'animsition-overlay-slide',
										overlayParentElement : 'body'
									});

					// // Window Height With Js
					// $('.angles-container').css({height: $(window).height()});
					// $('.main-content').css({height: $(window).height()});
					// $('.angles-content').css({height: $(window).height() -
					// 1000});

					// /* Slider Window Height */

					// $('#angles-slider').css({height: $(window).height()});
					// $('.sp-slides-container').css({height:
					// $(window).height()});
					// $('.sp-slides, .sp-slide').css({height:
					// $(window).height()});
					// $('.sp-mask.sp-grab').css({height: $(window).height()});
					// $('.sp-slide').css({height: $(window).height()});
					// $('.sp-image-container').css({height:
					// $(window).height()});
					// $('.sp-image').css({height: $(window).height()});

					/*-------- Magnific popUp ---------*/

					$('.image-popup-vertical-fit').magnificPopup({
						type : 'image',
						gallery : {
							enabled : true
						}
					});

					var homeSliderVagas = $("#homeSliderVagas");

					homeSliderVagas
							.owlCarousel({
								autoPlay : 3000,
								stopOnHover : true,
								navigation : true,
								paginationNumbers : false,
								navigationText : [
										"<i class='fa fa-angle-left post-prev'></i>",
										"<i class='fa fa-angle-right post-next'></i>" ],

								itemsCustom : [ [ 0, 1 ], [ 450, 1 ],
										[ 600, 1 ], [ 700, 2 ], [ 800, 3 ],
										[ 1000, 4 ], [ 1200, 4 ], ],
								// Responsive
								responsive : true,
								responsiveRefreshRate : 200,
								responsiveBaseWidth : window
							});

					var logoSlider = $("#logo-slider");

					logoSlider
							.owlCarousel({
								autoPlay : 3000,
								stopOnHover : true,
								navigation : true,
								paginationNumbers : false,
								navigationText : [
										"<i class='fa fa-angle-left post-prev'></i>",
										"<i class='fa fa-angle-right post-next'></i>" ],

								itemsCustom : [ [ 0, 1 ], [ 450, 2 ],
										[ 600, 2 ], [ 700, 2 ], [ 800, 3 ],
										[ 1000, 3 ], [ 1200, 3 ], ],
								// Responsive
								responsive : true,
								responsiveRefreshRate : 200,
								responsiveBaseWidth : window
							});

					// Works Isotope Gallery

					var $workItems = $('#work-items'), colWidth = function() {
						var w = $workItems.width(), columnNum = 1, columnWidth = 0;
						if (w > 1170) {
							columnNum = 4;
						} else if (w > 960) {
							columnNum = 3;
						} else if (w > 640) {
							columnNum = 3;
						} else if (w > 480) {
							columnNum = 2;
						} else if (w > 360) {
							columnNum = 1;
						}
						columnWidth = Math.floor(w / columnNum);
						$workItems
								.find('.item')
								.each(
										function() {
											var $item = $(this), multiplier_w = $item
													.attr('class').match(
															/item-w(\d)/), multiplier_h = $item
													.attr('class').match(
															/item-h(\d)/), width = multiplier_w ? columnWidth
													* multiplier_w[1]
													: columnWidth, height = multiplier_h ? columnWidth
													* multiplier_h[1]
													* 0.75
													- 10
													: columnWidth * 0.82 - 10;
											$item.css({
												width : width,
												height : height
											});
										});
						return columnWidth;
					}, isotope = function() {
						$workItems.isotope({
							resizable : true,
							itemSelector : '.item',
							masonry : {
								columnWidth : colWidth(),
								gutterWidth : 10
							}
						});
					};
					isotope();
					$(window).smartresize(isotope);

					$('.itemFilter a').on("click", function() {
						$('.itemFilter .current').removeClass('current');
						$(this).addClass('current');

						var selector = $(this).attr('data-filter');
						$workItems.isotope({
							filter : selector,
							animationOptions : {
								duration : 750,
								easing : 'linear',
								queue : false
							}
						});
						return false;
					});
				});

jQuery(document).ready(function($) {
	"use strict";

	$('#angles-slider').sliderPro({
		width : '100%',
		height : '95vh',
		fade : true,
		arrows : true,
		buttons : false,
		waitForLayers : false,
		autoplay : true,
		autoplayDelay : 4000,
		autoScaleLayers : false,
		touchSwipe : true,
		slideAnimationDuration : 3000
	});

	$('#counter').appear(function() {
		$('.counter').counterUp({
			delay : 20,
			time : 1000
		});
	});

	jQuery('#progressbar').appear(function() {
		$('.progress .progress-bar').progressbar({
			transition_delay : 500,
			refresh_speed : 10,
		});
	});

	$('#skills').appear(function() {
		$('.chart').each(function() {
			$(this).easyPieChart({
				size : 110,
				animate : 2000,
				lineCap : 'butt',
				scaleColor : false,
				barColor : '#222',
				lineWidth : 10,
				onStep : function(from, to, percent) {
					$(this.el).find('.data-percent').text(Math.round(percent));
				}
			});
		});
	});

	$('#btnNotRegistered').click(function() {
		$('#containerLogin').css('display', 'none')
		$('#containerNotRegistered').css('display', 'block')
	});
	
	$(' #btnForgot').click(function() {
		$('#containerLogin').css('display', 'none')
		$('#containerForgot').css('display', 'block')
	})
	
	$(' #btnBackLogin').click(function() {
		$('#containerLogin').css('display', 'block')
		$('#containerForgot').css('display', 'none')
	})

	$('#btnRegistered').click(function() {
		$('#containerLogin').css('display', 'block')
		$('#containerNotRegistered').css('display', 'none')
	})

	/*
	 * $('#registeredEmailForm').on('submit',function(event){
	 * event.preventDefault();
	 * 
	 * var self = $(this);
	 * 
	 * var parameter = { login: document.querySelector('#loginRegistered').value };
	 * 
	 * var formData = new FormData(this); formData.append("login",
	 * parameter.login);
	 * 
	 * $.ajax({ type : "POST", cache : false, url : self.attr('action'), data :
	 * formData, success : function(data) { location.href = self.attr('action') +
	 * '?login='+parameter.login; }, error: function() {
	 * $("#emailExist").css('display','block'); }, contentType: false,
	 * processData: false }); });
	 */

});

/*----------- Google Map - with support of gmaps.js ----------------*/

function isMobile() {
	return ('ontouchstart' in document.documentElement);
}

function init_gmap() {
	if (typeof google == 'undefined')
		return;
	var options = {
		center : [ -16.7003453, -49.2415762 ],
		zoom : 15,
		mapTypeControl : true,
		mapTypeControlOptions : {
			style : google.maps.MapTypeControlStyle.DROPDOWN_MENU
		},
		navigationControl : true,
		scrollwheel : false,
		streetViewControl : true
	}

	if (isMobile()) {
		options.draggable = false;
	}

	jQuery('#googleMaps').gmap3({
		map : {
			options : options
		},
		marker : {
			latLng : [ -16.7003453, -49.2415762 ],
			options : {
				icon : 'assets/img/mapicon.png'
			}
		}
	});
}

init_gmap();

/**
 * String.prototype.trim() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
 */
if (!String.prototype.trim) {
	String.prototype.trim = function() {
		return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	};
}

var truncate = function(elem, limit, after) {

	// Make sure an element and number of items to truncate is provided
	if (!elem || !limit)
		return;

	// Get the inner content of the element
	var content = elem.textContent || elem.innerText;
	content = content.trim();

	// Convert the content into an array of words
	// Remove any words above the limit
	content = content.split(' ').slice(0, limit);

	// Convert the array of words back into a string
	// If there's content to add after it, add it
	content = content.join(' ') + (after ? after : '');

	// Inject the content back into the DOM
	if (elem.textContent) {
		elem.textContent = content;
	} else {
		elem.innerText = content;
	}
};